import React, { useState, useEffect } from 'react';
import moment from 'moment';

import {
  Area,
  AreaChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  ReferenceLine,
} from 'recharts';

import { Text } from 'v3/components';

const getSpeed = (location) => {
  const speed = Number(location?.speed);

  return Number.isNaN(speed) ? null : speed;
};

const getFirstValue = (source, fieldNames = []) => {
  for (const fieldName of fieldNames) {
    const value = source?.[fieldName];

    if (value !== undefined && value !== null && value !== '') return value;
  }

  return null;
};

const hasAppLocationSource = (location) =>
  getFirstValue(location, ['battery_level', 'batteryLevel', 'battery']) !==
    null &&
  !getFirstValue(location, ['risk_manager_id', 'riskManagerId']);

const getLocationHour = (location, index) => {
  if (location?.hora) return location.hora;

  const capturedAt =
    location?.captured_at ||
    location?.capturedAt ||
    location?.captureData ||
    location?.datetime;

  if (capturedAt && moment(capturedAt).isValid()) {
    return moment(capturedAt).format('HH:mm');
  }

  return index + 1;
};

function SpeedViagem({ latLong, setCoords, handleClickVelocity }) {
  const [data, setData] = useState([]);
  const [labelSpeed, setlabelSpeed] = useState('');

  const setSpeedOrigin = (locations) => {
    const location = locations?.at(-1);

    if (
      !hasAppLocationSource(location) &&
      getFirstValue(location, ['risk_manager_id', 'riskManagerId'])
    ) {
      setlabelSpeed('Velocidade obtida via rastreador ');
    } else if (hasAppLocationSource(location)) {
      setlabelSpeed('Velocidade obtida via aplicativo');
    }
  };

  useEffect(() => {
    if (latLong?.length > 0) {
      const line = latLong
        .filter((el, index) => {
          const speed = getSpeed(el);

          if (speed === null || speed > 200) {
            return false;
          }

          if (index > 0) {
            const previousSpeed = getSpeed(latLong[index - 1]);
            const nextSpeed = getSpeed(latLong[index + 1]);

            let variance = previousSpeed !== null ? speed - previousSpeed : 0;

            let variance_after = nextSpeed !== null ? speed - nextSpeed : 0;
            if (variance < 0) {
              variance *= -1;
            }
            if (variance_after < 0) {
              variance_after *= -1;
            }
            if (variance > 50 || variance_after > 50) {
              return false;
            }
          }
          return true;
        })
        .map((el, index) => {
          const speed = getSpeed(el);

          return {
            ...el,
            hora: getLocationHour(el, index),
            velocidade: speed > 0 ? speed : null,
            latitude: getFirstValue(el, ['latitude', 'lat']),
            longitude: getFirstValue(el, ['longitude', 'lng', 'lon']),
            battery: getFirstValue(el, [
              'battery',
              'battery_level',
              'batteryLevel',
            ]),
            point: index,
          };
        });
      setData(line);
      setSpeedOrigin(line);
    } else {
      setData([]);
    }
  }, [latLong]);

  function onClick(chartData) {
    const activeTooltipIndex = Number(chartData?.activeTooltipIndex);
    const payload =
      chartData?.activePayload?.[0]?.payload ||
      (!Number.isNaN(activeTooltipIndex) ? data[activeTooltipIndex] : null);

    if (!payload) return;

    setCoords(payload);
    handleClickVelocity(payload);
  }

  return (
    <>
      {data.length > 0 && (
        <>
          <Text type="medium" style={{ fontStyle: 'italic' }}>
            {labelSpeed}
          </Text>
          <ResponsiveContainer width="101%" height={100}>
            <AreaChart
              height={90}
              data={data}
              onClick={onClick}
              margin={{
                top: 8,
                right: 21,
                left: 20,
              }}
            >
              <CartesianGrid strokeDasharray="3 3" vertical horizontal />
              <XAxis
                dataKey="hora"
                tickFormatter={() => ''}
                tickLine
              />
              <ReferenceLine
                y={60}
                label=""
                stroke="#FFc726"
                strokeDasharray="4 6"
                strokeWidth={2}
              />
              <ReferenceLine y={80} label="" stroke="red" strokeDasharray="3 3" />
              <Area
                type="monotone"
                dataKey="velocidade"
                stroke="#1C4B75"
                fill="#1C4B75"
                style={{ cursor: 'pointer' }}
                unit="km/h"
              />
              <YAxis unit="km/h" />
              <Tooltip />
              <Line
                unit="km/h"
                type="monotone"
                dataKey="velocidade"
                stroke="#1C4B75"
                dot={false}
                activeDot={{ r: 6 }}
              />
            </AreaChart>
          </ResponsiveContainer>
        </>
      )}
    </>
  );
}

export default SpeedViagem;
